// This object includes all the renames made in Sep 2025 when we updated our routes to match ember's naming conventions.
export default {
  "route:discovery-index": "route:discovery.index",
  "route:user-activity-drafts": "route:user-activity.drafts",
  "route:review-index": "route:review.index",
  "controller:review-index": "controller:review.index",
  "route:admin-dashboard": "route:admin.dashboard",
  "controller:admin-dashboard": "controller:admin.dashboard",
  "route:user-private-messages-user": "route:user-private-messages.user",
  "controller:user-private-messages-user":
    "controller:user-private-messages.user",
  "route:user-private-messages-user-index":
    "route:user-private-messages.user.index",
  "route:discourse-post-event-upcoming-events-default-index":
    "route:discourse-post-event-upcoming-events.default-index",
  "route:discovery-categories": "route:discovery.categories",
  "route:tag-show": "route:tag.show",
  "route:tags-index": "route:tags.index",
  "controller:tags-index": "controller:tags.index",
  "route:chat-channel": "route:chat.channel",
  "controller:chat-channel": "controller:chat.channel",
  "controller:chat-channel-index": "controller:chat.channel.index",
  "route:chat-new-message": "route:chat.new-message",
  "controller:chat-new-message": "controller:chat.new-message",
  "controller:edit-category-tabs": "controller:edit-category.tabs",
  "route:edit-category-tabs": "route:edit-category.tabs",
  "controller:group-requests": "controller:group.requests",
  "route:group-requests": "route:group.requests",
  "controller:group-activity-posts": "controller:group.activity.posts",
  "route:group-activity-posts": "route:group.activity.posts",
  "controller:group-activity-topics": "controller:group.activity.topics",
  "route:group-activity-topics": "route:group.activity.topics",
  "controller:group-assigned-show": "controller:group.assigned.show",
  "route:group-assigned-show": "route:group.assigned.show",
  "controller:group-reports-show": "controller:group.reports.show",
  "route:group-reports-show": "route:group.reports.show",
  "controller:group-reports-index": "controller:group.reports.index",
  "route:group-reports-index": "route:group.reports.index",
  "controller:group-index": "controller:group.index",
  "route:group-index": "route:group.index",
  "route:user-activity-pending": "route:user-activity.pending",
  "controller:user-activity-assigned": "controller:user-activity.assigned",
  "route:user-activity-assigned": "route:user-activity.assigned",
  "controller:user-activity-reactions": "controller:user-activity.reactions",
  "route:user-activity-reactions": "route:user-activity.reactions",
  "route:user-activity-solved": "route:user-activity.solved",
  "controller:user-private-messages-group":
    "controller:user-private-messages.group",
  "route:user-private-messages-group": "route:user-private-messages.group",
  "controller:user-private-messages-tags-index":
    "controller:user-private-messages.tags.index",
  "route:user-private-messages-tags-index":
    "route:user-private-messages.tags.index",
  "controller:user-private-messages-tags":
    "controller:user-private-messages.tags",
  "route:user-private-messages-tags": "route:user-private-messages.tags",
  "route:preferences-email": "route:preferences.email",
  "route:preferences-second-factor": "route:preferences.second-factor",
  "controller:user-invited-show": "controller:user-invited.show",
  "route:user-invited-show": "route:user-invited.show",
  "route:review-show": "route:review.show",
  "route:review-topics": "route:review.topics",
  "controller:review-settings": "controller:review.settings",
  "route:review-settings": "route:review.settings",
  "controller:tag-groups-edit": "controller:tag-groups.edit",
  "route:tag-groups-edit": "route:tag-groups.edit",
  "controller:tag-groups-new": "controller:tag-groups.new",
  "route:tag-groups-new": "route:tag-groups.new",
  "route:chat-channel-threads": "route:chat.channel.threads",
  "controller:chat-channel-thread": "controller:chat.channel.thread",
  "route:chat-channel-thread": "route:chat.channel.thread",
  "route:chat-direct-messages": "route:chat.direct-messages",
  "route:chat-channels": "route:chat.channels",
  "route:chat-threads": "route:chat.threads",
  "route:chat-channel-info-members": "route:chat.channel.info.members",
  "route:chat-channel-info": "route:chat.channel.info",
  "route:chat-browse-archived": "route:chat.browse.archived",
  "controller:chat-index": "controller:chat.index",
  "route:chat-index": "route:chat.index",
  "controller:discourse-post-event-upcoming-events-index":
    "controller:discourse-post-event-upcoming-events.index",
  "route:discourse-post-event-upcoming-events-index":
    "route:discourse-post-event-upcoming-events.index",
  "controller:discourse-post-event-upcoming-events-mine":
    "controller:discourse-post-event-upcoming-events.mine",
  "route:discourse-post-event-upcoming-events-mine":
    "route:discourse-post-event-upcoming-events.mine",
  "route:gamification-leaderboard-by-name":
    "route:gamification-leaderboard.by-name",
  "route:gamification-leaderboard-index":
    "route:gamification-leaderboard.index",
  "controller:admin-groups-settings": "controller:admin-groups.settings",
  "route:admin-groups-settings": "route:admin-groups.settings",
  "controller:admin-groups-index": "controller:admin-groups.index",
  "route:admin-groups-index": "route:admin-groups.index",
  "route:admin-schema": "route:admin.schema",
  "controller:groups-new": "controller:groups.new",
  "route:groups-new": "route:groups.new",
  "controller:groups-index": "controller:groups.index",
  "route:groups-index": "route:groups.index",
  "controller:group-activity": "controller:group.activity",
  "controller:group-manage-profile": "controller:group.manage.profile",
  "route:group-manage-profile": "route:group.manage.profile",
  "controller:group-manage-categories": "controller:group.manage.categories",
  "route:group-manage-categories": "route:group.manage.categories",
  "controller:group-manage-tags": "controller:group.manage.tags",
  "route:group-manage-tags": "route:group.manage.tags",
  "controller:group-manage-logs": "controller:group.manage.logs",
  "route:group-manage-logs": "route:group.manage.logs",
  "controller:group-manage": "controller:group.manage",
  "route:group-manage": "route:group.manage",
  "controller:group-messages": "controller:group.messages",
  "route:group-messages": "route:group.messages",
  "controller:group-permissions": "controller:group.permissions",
  "route:group-permissions": "route:group.permissions",
  "controller:group-assigned": "controller:group.assigned",
  "route:group-assigned": "route:group.assigned",
  "controller:account-created-edit-email":
    "controller:account-created.edit-email",
  "route:account-created-edit-email": "route:account-created.edit-email",
  "controller:account-created-index": "controller:account-created.index",
  "route:account-created-index": "route:account-created.index",
  "controller:user-summary": "controller:user.summary",
  "route:user-summary": "route:user.summary",
  "controller:user-activity-bookmarks": "controller:user-activity.bookmarks",
  "route:user-activity-bookmarks": "route:user-activity.bookmarks",
  "controller:user-badges": "controller:user.badges",
  "route:user-badges": "route:user.badges",
  "controller:preferences-chat": "controller:preferences.chat",
  "route:preferences-chat": "route:preferences.chat",
  "controller:preferences-ai": "controller:preferences.ai",
  "route:preferences-ai": "route:preferences.ai",
  "controller:user-billing-subscriptions-card":
    "controller:user.billing.subscriptions.card",
  "route:user-billing-subscriptions-card":
    "route:user.billing.subscriptions.card",
  "controller:tags-intersection": "controller:tags.intersection",
  "route:tags-intersection": "route:tags.intersection",
  "controller:invites-show": "controller:invites.show",
  "route:invites-show": "route:invites.show",
  "controller:subscribe-show": "controller:subscribe.show",
  "route:subscribe-show": "route:subscribe.show",
  "controller:subscribe-index": "controller:subscribe.index",
  "route:subscribe-index": "route:subscribe.index",
  "controller:admin-email-logs-sent": "controller:admin-email-logs.sent",
  "route:admin-email-logs-sent": "route:admin-email-logs.sent",
  "controller:admin-email-logs-skipped": "controller:admin-email-logs.skipped",
  "route:admin-email-logs-skipped": "route:admin-email-logs.skipped",
  "controller:admin-email-logs-bounced": "controller:admin-email-logs.bounced",
  "route:admin-email-logs-bounced": "route:admin-email-logs.bounced",
  "controller:admin-email-logs-received":
    "controller:admin-email-logs.received",
  "route:admin-email-logs-received": "route:admin-email-logs.received",
  "controller:admin-email-logs-rejected":
    "controller:admin-email-logs.rejected",
  "route:admin-email-logs-rejected": "route:admin-email-logs.rejected",
  "controller:admin-email-settings": "controller:admin-email.settings",
  "route:admin-email-settings": "route:admin-email.settings",
  "controller:admin-email-server-settings":
    "controller:admin-email.server-settings",
  "route:admin-email-server-settings": "route:admin-email.server-settings",
  "controller:admin-email-preview-digest":
    "controller:admin-email.preview-digest",
  "route:admin-email-preview-digest": "route:admin-email.preview-digest",
  "controller:admin-email-advanced-test":
    "controller:admin-email.advanced-test",
  "controller:admin-email-templates-edit":
    "controller:admin-email-templates.edit",
  "route:admin-email-templates-edit": "route:admin-email-templates.edit",
  "controller:admin-customize-themes-show-index":
    "controller:admin-customize-themes.show.index",
  "route:admin-customize-themes-show-index":
    "route:admin-customize-themes.show.index",
  "controller:admin-customize-themes-show":
    "controller:admin-customize-themes.show",
  "route:admin-customize-themes-show": "route:admin-customize-themes.show",
  "controller:admin-customize-themes-edit":
    "controller:admin-customize-themes.edit",
  "route:admin-customize-themes-edit": "route:admin-customize-themes.edit",
  "controller:admin-site-text-edit": "controller:admin-site-text.edit",
  "route:admin-site-text-edit": "route:admin-site-text.edit",
  "controller:admin-site-text-index": "controller:admin-site-text.index",
  "route:admin-site-text-index": "route:admin-site-text.index",
  "controller:admin-embedding-index": "controller:admin-embedding.index",
  "controller:admin-embedding-settings": "controller:admin-embedding.settings",
  "controller:admin-embedding-posts-and-topics":
    "controller:admin-embedding.posts-and-topics",
  "controller:admin-embedding-crawlers": "controller:admin-embedding.crawlers",
  "controller:admin-customize-email-style-edit":
    "controller:admin-customize-email-style.edit",
  "route:admin-customize-email-style-edit":
    "route:admin-customize-email-style.edit",
  "controller:admin-customize-form-templates-index":
    "controller:admin-customize-form-templates.index",
  "route:admin-customize-form-templates-index":
    "route:admin-customize-form-templates.index",
  "controller:admin-watched-words-action":
    "controller:admin-watched-words.action",
  "route:admin-watched-words-action": "route:admin-watched-words.action",
  "controller:admin-api-keys-settings": "controller:admin-api-keys.settings",
  "route:admin-api-keys-settings": "route:admin-api-keys.settings",
  "controller:admin-api-keys-new": "controller:admin-api-keys.new",
  "route:admin-api-keys-new": "route:admin-api-keys.new",
  "controller:admin-api-keys-index": "controller:admin-api-keys.index",
  "route:admin-api-keys-index": "route:admin-api-keys.index",
  "controller:admin-web-hooks-show": "controller:admin-web-hooks.show",
  "route:admin-web-hooks-show": "route:admin-web-hooks.show",
  "controller:admin-web-hooks-edit": "controller:admin-web-hooks.edit",
  "route:admin-web-hooks-edit": "route:admin-web-hooks.edit",
  "controller:admin-web-hooks-index": "controller:admin-web-hooks.index",
  "route:admin-web-hooks-index": "route:admin-web-hooks.index",
  "controller:admin-backups-logs": "controller:admin.backups.logs",
  "route:admin-backups-logs": "route:admin.backups.logs",
  "controller:admin-backups": "controller:admin.backups",
  "route:admin-backups": "route:admin.backups",
  "controller:admin-backups-settings": "controller:admin.backups.settings",
  "route:admin-backups-settings": "route:admin.backups.settings",
  "controller:admin-backups-index": "controller:admin.backups.index",
  "route:admin-backups-index": "route:admin.backups.index",
  "controller:admin-reports-show": "controller:admin-reports.show",
  "route:admin-reports-show": "route:admin-reports.show",
  "controller:admin-reports-dashboard-settings":
    "controller:admin-reports.dashboard-settings",
  "route:admin-reports-dashboard-settings":
    "route:admin-reports.dashboard-settings",
  "controller:admin-logs-staff-action-logs":
    "controller:admin-logs.staff-action-logs",
  "route:admin-logs-staff-action-logs": "route:admin-logs.staff-action-logs",
  "controller:admin-logs-screened-emails":
    "controller:admin-logs.screened-emails",
  "route:admin-logs-screened-emails": "route:admin-logs.screened-emails",
  "controller:admin-logs-screened-ip-addresses":
    "controller:admin-logs.screened-ip-addresses",
  "route:admin-logs-screened-ip-addresses":
    "route:admin-logs.screened-ip-addresses",
  "controller:admin-logs-screened-urls": "controller:admin-logs.screened-urls",
  "route:admin-logs-screened-urls": "route:admin-logs.screened-urls",
  "controller:admin-search-logs-index": "controller:admin-search-logs.index",
  "route:admin-search-logs-index": "route:admin-search-logs.index",
  "controller:admin-search-logs-term": "controller:admin-search-logs.term",
  "route:admin-search-logs-term": "route:admin-search-logs.term",
  "controller:admin-users-settings": "controller:admin-users.settings",
  "route:admin-users-settings": "route:admin-users.settings",
  "controller:admin-user-badges": "controller:admin-user.badges",
  "route:admin-user-badges": "route:admin-user.badges",
  "controller:admin-user-index": "controller:admin-user.index",
  "route:admin-user-index": "route:admin-user.index",
  "controller:admin-users-list-show": "controller:admin-users-list.show",
  "route:admin-users-list-show": "route:admin-users-list.show",
  "controller:admin-config-flags-settings":
    "controller:admin-config.flags.settings",
  "route:admin-config-flags-settings": "route:admin-config.flags.settings",
  "controller:admin-config-login-and-authentication-settings":
    "controller:admin-config.login-and-authentication.settings",
  "controller:admin-config-content-categories-and-tags":
    "controller:admin-config.content.categories-and-tags",
  "route:admin-config-content-categories-and-tags":
    "route:admin-config.content.categories-and-tags",
  "controller:admin-config-content-settings":
    "controller:admin-config.content.settings",
  "route:admin-config-content-settings": "route:admin-config.content.settings",
  "controller:admin-config-content-sharing":
    "controller:admin-config.content.sharing",
  "route:admin-config-content-sharing": "route:admin-config.content.sharing",
  "controller:admin-config-content-posts-and-topics":
    "controller:admin-config.content.posts-and-topics",
  "route:admin-config-content-posts-and-topics":
    "route:admin-config.content.posts-and-topics",
  "controller:admin-config-content-stats-and-thresholds":
    "controller:admin-config.content.stats-and-thresholds",
  "route:admin-config-content-stats-and-thresholds":
    "route:admin-config.content.stats-and-thresholds",
  "controller:admin-config-localization-settings":
    "controller:admin-config.localization.settings",
  "controller:admin-config-notifications-settings":
    "controller:admin-config.notifications.settings",
  "controller:admin-config-search-settings":
    "controller:admin-config.search.settings",
  "controller:admin-config-legal-settings":
    "controller:admin-config.legal.settings",
  "controller:admin-config-experimental-settings":
    "controller:admin-config.experimental.settings",
  "controller:admin-config-files-settings":
    "controller:admin-config.files.settings",
  "controller:admin-config-interface-settings":
    "controller:admin-config.interface.settings",
  "route:admin-config-interface-settings":
    "route:admin-config.interface.settings",
  "controller:admin-config-group-permissions-settings":
    "controller:admin-config.group-permissions.settings",
  "controller:admin-config-user-defaults-settings":
    "controller:admin-config.user-defaults.settings",
  "route:admin-config-user-defaults-settings":
    "route:admin-config.user-defaults.settings",
  "controller:admin-config-site-admin-settings":
    "controller:admin-config.site-admin.settings",
  "route:admin-config-site-admin-settings":
    "route:admin-config.site-admin.settings",
  "controller:admin-config-trust-levels-settings":
    "controller:admin-config.trust-levels.settings",
  "controller:admin-analytics-settings": "controller:admin-analytics.settings",
  "controller:admin-permalinks-index": "controller:admin-permalinks.index",
  "route:admin-permalinks-index": "route:admin-permalinks.index",
  "controller:admin-permalinks-settings":
    "controller:admin-permalinks.settings",
  "controller:admin-emojis-settings": "controller:admin-emojis.settings",
  "route:admin-emojis-settings": "route:admin-emojis.settings",
  "controller:admin-config-developer-settings":
    "controller:admin-config.developer.settings",
  "controller:admin-config-navigation-settings":
    "controller:admin-config.navigation.settings",
  "controller:admin-config-onebox-settings":
    "controller:admin-config.onebox.settings",
  "controller:admin-config-rate-limits-settings":
    "controller:admin-config.rate-limits.settings",
  "controller:admin-config-security-settings":
    "controller:admin-config.security.settings",
  "controller:admin-config-spam-settings":
    "controller:admin-config.spam.settings",
  "controller:admin-config-color-palettes-show":
    "controller:admin-config.color-palettes.show",
  "route:admin-config-color-palettes-show":
    "route:admin-config.color-palettes.show",
  "controller:admin-config-color-palettes-index":
    "controller:admin-config.color-palettes.index",
  "route:admin-config-color-palettes-index":
    "route:admin-config.color-palettes.index",
  "controller:admin-plugins-index": "controller:admin-plugins.index",
  "route:admin-plugins-index": "route:admin-plugins.index",
  "controller:admin-plugins-show-settings":
    "controller:admin-plugins.show.settings",
  "route:admin-plugins-show-settings": "route:admin-plugins.show.settings",
  "controller:admin-plugins-show-discourse-gamification-leaderboards-index":
    "controller:admin-plugins.show.discourse-gamification-leaderboards.index",
  "controller:admin-plugins-house-ads-index":
    "controller:admin-plugins.house-ads.index",
  "route:admin-plugins-house-ads-index": "route:admin-plugins.house-ads.index",
  "controller:admin-plugins-house-ads": "controller:admin-plugins.house-ads",
  "route:admin-plugins-house-ads": "route:admin-plugins.house-ads",
  "controller:admin-plugins-house-ads-show":
    "controller:admin-plugins.house-ads.show",
  "route:admin-plugins-house-ads-show": "route:admin-plugins.house-ads.show",
  "controller:admin-plugins-chat-integration-provider":
    "controller:admin-plugins.chat-integration.provider",
  "route:admin-plugins-chat-integration-provider":
    "route:admin-plugins.chat-integration.provider",
  "controller:admin-plugins-chat-integration":
    "controller:admin-plugins.chat-integration",
  "route:admin-plugins-chat-integration":
    "route:admin-plugins.chat-integration",
  "controller:admin-plugins-explorer-queries-details":
    "controller:admin-plugins.explorer.queries.details",
  "route:admin-plugins-explorer-queries-details":
    "route:admin-plugins.explorer.queries.details",
  "controller:admin-plugins-explorer-index":
    "controller:admin-plugins.explorer.index",
  "route:admin-plugins-explorer-index": "route:admin-plugins.explorer.index",
  "controller:admin-plugins-patreon": "controller:admin-plugins.patreon",
  "route:admin-plugins-patreon": "route:admin-plugins.patreon",
  "controller:admin-plugins-discourse-subscriptions-products-show-plans-show":
    "controller:admin-plugins.discourse-subscriptions.products.show.plans.show",
  "route:admin-plugins-discourse-subscriptions-products-show-plans-show":
    "route:admin-plugins.discourse-subscriptions.products.show.plans.show",
  "controller:admin-plugins-discourse-subscriptions-products-show":
    "controller:admin-plugins.discourse-subscriptions.products.show",
  "route:admin-plugins-discourse-subscriptions-products-show":
    "route:admin-plugins.discourse-subscriptions.products.show",
  "controller:admin-plugins-discourse-subscriptions-products-index":
    "controller:admin-plugins.discourse-subscriptions.products.index",
  "route:admin-plugins-discourse-subscriptions-products-index":
    "route:admin-plugins.discourse-subscriptions.products.index",
  "controller:admin-plugins-discourse-subscriptions-coupons":
    "controller:admin-plugins.discourse-subscriptions.coupons",
  "route:admin-plugins-discourse-subscriptions-coupons":
    "route:admin-plugins.discourse-subscriptions.coupons",
  "controller:admin-plugins-discourse-subscriptions-subscriptions":
    "controller:admin-plugins.discourse-subscriptions.subscriptions",
  "route:admin-plugins-discourse-subscriptions-subscriptions":
    "route:admin-plugins.discourse-subscriptions.subscriptions",
  "controller:admin-plugins-discourse-subscriptions":
    "controller:admin-plugins.discourse-subscriptions",
  "route:admin-plugins-discourse-subscriptions":
    "route:admin-plugins.discourse-subscriptions",
  "controller:admin-whats-new": "controller:admin.whats-new",
  "route:admin-whats-new": "route:admin.whats-new",
  "controller:admin-search-index": "controller:admin-search.index",
  "route:admin-search-index": "route:admin-search.index",
  "route:topic-from-params": "route:topic.from-params",
  "route:topic-from-params-near": "route:topic.from-params-near",
  "route:edit-category-index": "route:edit-category.index",
  "route:discovery-filter": "route:discovery.filter",
  "route:discovery-subcategories": "route:discovery.subcategories",
  "route:discovery-login-required": "route:discovery.login-required",
  "route:group-members": "route:group.members",
  "route:group-activity-mentions": "route:group.activity.mentions",
  "route:group-activity-index": "route:group.activity.index",
  "route:group-manage-membership": "route:group.manage.membership",
  "route:group-manage-interaction": "route:group.manage.interaction",
  "route:group-manage-email": "route:group.manage.email",
  "route:group-manage-index": "route:group.manage.index",
  "route:group-messages-inbox": "route:group.messages.inbox",
  "route:group-messages-archive": "route:group.messages.archive",
  "route:group-messages-index": "route:group.messages.index",
  "route:account-created-resent": "route:account-created.resent",
  "route:user-activity-topics": "route:user-activity.topics",
  "route:user-activity-replies": "route:user-activity.replies",
  "route:user-activity-likes-given": "route:user-activity.likes-given",
  "route:user-activity-bookmarks-with-reminders":
    "route:user-activity.bookmarks-with-reminders",
  "route:user-activity-read": "route:user-activity.read",
  "route:user-activity-votes": "route:user-activity.votes",
  "route:user-activity-index": "route:user-activity.index",
  "route:user-notifications-responses": "route:user-notifications.responses",
  "route:user-notifications-likes-received":
    "route:user-notifications.likes-received",
  "route:user-notifications-mentions": "route:user-notifications.mentions",
  "route:user-notifications-edits": "route:user-notifications.edits",
  "route:user-notifications-links": "route:user-notifications.links",
  "route:user-notifications-reactions-received":
    "route:user-notifications.reactions-received",
  "route:user-notifications-index": "route:user-notifications.index",
  "route:user-deleted-posts": "route:user.deleted-posts",
  "route:user-private-messages-user-new":
    "route:user-private-messages.user.new",
  "route:user-private-messages-user-unread":
    "route:user-private-messages.user.unread",
  "route:user-private-messages-user-archive":
    "route:user-private-messages.user.archive",
  "route:user-private-messages-user-sent":
    "route:user-private-messages.user.sent",
  "route:user-private-messages-user-warnings":
    "route:user-private-messages.user.warnings",
  "route:user-private-messages-group-archive":
    "route:user-private-messages.group.archive",
  "route:user-private-messages-group-new":
    "route:user-private-messages.group.new",
  "route:user-private-messages-group-unread":
    "route:user-private-messages.group.unread",
  "route:user-private-messages-group-index":
    "route:user-private-messages.group.index",
  "route:user-private-messages-tags-show":
    "route:user-private-messages.tags.show",
  "route:user-private-messages-assigned-index":
    "route:user-private-messages.assigned.index",
  "route:preferences-account": "route:preferences.account",
  "route:preferences-security": "route:preferences.security",
  "route:preferences-profile": "route:preferences.profile",
  "route:preferences-emails": "route:preferences.emails",
  "route:preferences-notifications": "route:preferences.notifications",
  "route:preferences-tracking": "route:preferences.tracking",
  "route:preferences-users": "route:preferences.users",
  "route:preferences-tags": "route:preferences.tags",
  "route:preferences-interface": "route:preferences.interface",
  "route:preferences-apps": "route:preferences.apps",
  "route:preferences-navigation-menu": "route:preferences.navigation-menu",
  "route:preferences-index": "route:preferences.index",
  "route:user-invited-index": "route:user-invited.index",
  "route:user-billing-payments": "route:user.billing.payments",
  "route:user-billing-subscriptions-index":
    "route:user.billing.subscriptions.index",
  "route:user-billing-subscriptions": "route:user.billing.subscriptions",
  "route:user-billing-index": "route:user.billing.index",
  "route:user-billing": "route:user.billing",
  "route:user-index": "route:user.index",
  "route:badges-show": "route:badges.show",
  "route:badges-index": "route:badges.index",
  "route:tags-legacy-redirect": "route:tags.legacy-redirect",
  "route:chat-channel-near-message": "route:chat.channel.near-message",
  "route:chat-channel-near-message-with-thread":
    "route:chat.channel.near-message-with-thread",
  "route:chat-channel-thread-near-message":
    "route:chat.channel.thread.near-message",
  "route:chat-channel-info-index": "route:chat.channel.info.index",
  "route:chat-browse-index": "route:chat.browse.index",
  "route:discourse-post-event-upcoming-events-default-mine":
    "route:discourse-post-event-upcoming-events.default-mine",
  "route:admin-site-settings-index": "route:admin-site-settings.index",
  "route:admin-customize-colors": "route:admin-customize.colors",
  "route:admin-customize-colors-show": "route:admin-customize.colors-show",
  "route:admin-customize-themes-show-schema":
    "route:admin-customize-themes.show.schema",
  "route:admin-customize-themes-index": "route:admin-customize-themes.index",
  "route:admin-embedding-new": "route:admin-embedding.new",
  "route:admin-embedding-edit": "route:admin-embedding.edit",
  "route:admin-customize-email-style-index":
    "route:admin-customize-email-style.index",
  "route:admin-customize-form-templates-edit":
    "route:admin-customize-form-templates.edit",
  "route:admin-watched-words-index": "route:admin-watched-words.index",
  "route:admin-customize-index": "route:admin-customize.index",
  "route:admin-api-keys-show": "route:admin-api-keys.show",
  "route:admin-web-hooks-new": "route:admin-web-hooks.new",
  "route:admin-api-index": "route:admin-api.index",
  "route:admin-logs-index": "route:admin-logs.index",
  "route:admin-user-tl3-requirements": "route:admin-user.tl3-requirements",
  "route:admin-users-list-index": "route:admin-users-list.index",
  "route:admin-users-index": "route:admin-users.index",
  "route:admin-config-flags-index": "route:admin-config.flags.index",
  "route:admin-config-flags-edit": "route:admin-config.flags.edit",
  "route:admin-config-about": "route:admin-config.about",
  "route:admin-config-login-and-authentication":
    "route:admin-config.login-and-authentication",
  "route:admin-config-localization": "route:admin-config.localization",
  "route:admin-config-notifications": "route:admin-config.notifications",
  "route:admin-config-search": "route:admin-config.search",
  "route:admin-config-legal": "route:admin-config.legal",
  "route:admin-config-experimental": "route:admin-config.experimental",
  "route:admin-config-files": "route:admin-config.files",
  "route:admin-config-group-permissions":
    "route:admin-config.group-permissions",
  "route:admin-config-trust-levels": "route:admin-config.trust-levels",
  "route:admin-config-customize-themes": "route:admin-config.customize.themes",
  "route:admin-config-customize-components":
    "route:admin-config.customize.components",
  "route:admin-config-customize-index": "route:admin-config.customize.index",
  "route:admin-config-customize": "route:admin-config.customize",
  "route:admin-permalinks-edit": "route:admin-permalinks.edit",
  "route:admin-user-fields-new": "route:admin-user-fields.new",
  "route:admin-user-fields-edit": "route:admin-user-fields.edit",
  "route:admin-config-developer": "route:admin-config.developer",
  "route:admin-config-logo": "route:admin-config.logo",
  "route:admin-config-fonts": "route:admin-config.fonts",
  "route:admin-config-navigation": "route:admin-config.navigation",
  "route:admin-config-onebox": "route:admin-config.onebox",
  "route:admin-config-rate-limits": "route:admin-config.rate-limits",
  "route:admin-config-security": "route:admin-config.security",
  "route:admin-config-spam": "route:admin-config.spam",
  "route:admin-plugins-show-automation-new":
    "route:admin-plugins.show.automation.new",
  "route:admin-plugins-show-automation-edit":
    "route:admin-plugins.show.automation.edit",
  "route:admin-plugins-show-automation-index":
    "route:admin-plugins.show.automation.index",
  "route:admin-plugins-show-discourse-chat-incoming-webhooks-new":
    "route:admin-plugins.show.discourse-chat-incoming-webhooks.new",
  "route:admin-plugins-show-discourse-chat-incoming-webhooks-edit":
    "route:admin-plugins.show.discourse-chat-incoming-webhooks.edit",
  "route:admin-plugins-show-discourse-chat-incoming-webhooks-index":
    "route:admin-plugins.show.discourse-chat-incoming-webhooks.index",
  "route:admin-plugins-show-discourse-ai-personas-new":
    "route:admin-plugins.show.discourse-ai-personas.new",
  "route:admin-plugins-show-discourse-ai-personas-edit":
    "route:admin-plugins.show.discourse-ai-personas.edit",
  "route:admin-plugins-show-discourse-ai-personas":
    "route:admin-plugins.show.discourse-ai-personas",
  "route:admin-plugins-show-discourse-ai-llms-new":
    "route:admin-plugins.show.discourse-ai-llms.new",
  "route:admin-plugins-show-discourse-ai-llms-edit":
    "route:admin-plugins.show.discourse-ai-llms.edit",
  "route:admin-plugins-show-discourse-ai-llms":
    "route:admin-plugins.show.discourse-ai-llms",
  "route:admin-plugins-show-discourse-ai-tools-new":
    "route:admin-plugins.show.discourse-ai-tools.new",
  "route:admin-plugins-show-discourse-ai-tools-edit":
    "route:admin-plugins.show.discourse-ai-tools.edit",
  "route:admin-plugins-show-discourse-ai-tools":
    "route:admin-plugins.show.discourse-ai-tools",
  "route:admin-plugins-show-discourse-ai-spam":
    "route:admin-plugins.show.discourse-ai-spam",
  "route:admin-plugins-show-discourse-ai-translations":
    "route:admin-plugins.show.discourse-ai-translations",
  "route:admin-plugins-show-discourse-ai-usage":
    "route:admin-plugins.show.discourse-ai-usage",
  "route:admin-plugins-show-discourse-ai-embeddings-new":
    "route:admin-plugins.show.discourse-ai-embeddings.new",
  "route:admin-plugins-show-discourse-ai-embeddings-edit":
    "route:admin-plugins.show.discourse-ai-embeddings.edit",
  "route:admin-plugins-show-discourse-ai-embeddings":
    "route:admin-plugins.show.discourse-ai-embeddings",
  "route:admin-plugins-show-discourse-ai-features-edit":
    "route:admin-plugins.show.discourse-ai-features.edit",
  "route:admin-plugins-show-discourse-ai-features":
    "route:admin-plugins.show.discourse-ai-features",
  "route:admin-plugins-show-discourse-gamification-leaderboards-show":
    "route:admin-plugins.show.discourse-gamification-leaderboards.show",
  "route:admin-plugins-show-discourse-gamification-leaderboards":
    "route:admin-plugins.show.discourse-gamification-leaderboards",
  "route:admin-plugins-show-index": "route:admin-plugins.show.index",
  "route:admin-plugins-show": "route:admin-plugins.show",
  "route:admin-plugins-chat-integration-index":
    "route:admin-plugins.chat-integration.index",
  "route:admin-plugins-discourse-subscriptions-products":
    "route:admin-plugins.discourse-subscriptions.products",
};
